import { HelpLink } from 'elements/link/HelpLink'
import { Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const TagTitle = ({ record, translate, style }) => {
  return (
    <Typography variant="body2" style={style}>
      {translate('Project Tag')}: {record ? `"${record.title}"` : ''}
    </Typography>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <Typography variant="body2">
      {translate(
        'Create your own Project Tags that you can apply to projects to enable easy filtering and sorting. For example: "Family and Friends"'
      )}
      .
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12362628522255-How-to-customize-project-tags-and-actions" />
    </Typography>
  )
}

export default {
  list: { lazy: () => import('./Tags'), component: 'TagList' },
  edit: { lazy: () => import('./Tags'), component: 'TagEdit' },
  create: { lazy: () => import('./Tags'), component: 'TagCreate' },
  options: {
    create: {
      title: 'Create Tag',
      subtitle: null,
      breadCrumb: 'Create Tag',
    },
    list: {
      title: 'Project Tags',
      subtitle: <Subtitle />,
      breadCrumb: 'Project Tags',
    },
    edit: {
      title: <TagTitle />,
      subtitle: null,
      breadCrumb: 'Edit Tag',
    },
  },
}
